<template>
    <div :class="`short-text short-text-align-${localAlign}`">
        <label for="short-text" class="field-label" @click="focusFieldLabel" v-if="!editingFieldLabel">
            {{ displayFieldLabel }}
            <span v-if="isRequired" class="required-indicator">*</span>
        </label>
        <input
            v-if="editingFieldLabel"
            type="text"
            class="field-label-input"
            placeholder="Bir soru girin"
            v-model="localFieldLabel"
            @blur="stopEditingFieldLabel"
            @keydown.enter="stopEditingFieldLabel"
            ref="fieldLabelInput"
        />
        <div class="input-container">
            <div :class="['input-wrapper', { 'filled': shortTextValue }]">
                <input
                    type="text"
                    id="short-text"
                    name="short-text"
                    v-model="shortTextValue"
                    @input="updateField"
                    @focus="onFocus"
                    @blur="onBlur"
                    :class="{ 'has-value': shortTextValue }"
                />
                <div class="input-border"></div>
            </div>
            <label for="short-text" class="input-label">{{ altLabel || 'Cevabınızı buraya yazınız' }}</label>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "FormShortText",
    props: {
        fieldLabel: String,
        align: String,
        altLabel: String,
        item: Object,
        isRequired: Boolean,
    },
    data() {
        return {
            localFieldLabel: this.fieldLabel || "",
            localAlign: this.align || "top",
            localAltLabel: this.altLabel || "",
            shortTextValue: "",
            editingFieldLabel: false,
            updateTimer: null,
        };
    },
    computed: {
        displayFieldLabel() {
            return this.localFieldLabel || "Bir soru girin";
        },
    },
    methods: {
        ...mapActions("forms", ["updateFormField"]),
        focusFieldLabel() {
            this.editingFieldLabel = true;
            this.$nextTick(() => {
                if (this.$refs.fieldLabelInput) {
                    this.$refs.fieldLabelInput.focus();
                }
            });
        },
        stopEditingFieldLabel() {
            this.editingFieldLabel = false;
            this.updateField();
        },
        onFocus(event) {
            event.target.parentElement.classList.add('focused');
        },
        onBlur(event) {
            event.target.parentElement.classList.remove('focused');
        },
        updateField() {
            let self = this;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            this.updateTimer = setTimeout(function () {
            const updateFields = {
                shortText: {
                        fieldLabel: self.localFieldLabel,
                        align: self.localAlign,
                        altLabel: self.localAltLabel,
                        isRequired: self.isRequired,
                    },
                };
                self.updateFormField({
                    siteId: self.item.siteId,
                    formFieldId: self.item._id,
                updateFields: updateFields,
            });
                self.$emit("update-field", updateFields);
            }, 200);
        },
    },
    watch: {
        fieldLabel(newVal) {
            this.localFieldLabel = newVal;
        },
        align(newVal) {
            this.localAlign = newVal;
        },
        altLabel(newVal) {
            this.localAltLabel = newVal;
        },
    },
};
</script>

<style lang="scss" scoped>
/* Base ShortText Styles */
.short-text {
    width: 100%;
    max-width: 700px;
    margin: clamp(0.5rem, 1.5vw, 1rem) auto;
    padding: clamp(0.625rem, 1.5vw, 0.875rem);
    position: relative;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

    background: linear-gradient(145deg,
        rgba(255, 255, 255, 0.02) 0%,
        rgba(255, 255, 255, 0.01) 100%);
    border-radius: 0.75rem;
    border: 1px solid rgba(255, 255, 255, 0.06);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
        background: linear-gradient(145deg,
            rgba(255, 255, 255, 0.03) 0%,
            rgba(255, 255, 255, 0.02) 100%);
    }

    .field-label {
        display: block;
        font-size: clamp(0.95rem, 2.2vw, 1.1rem);
        font-weight: 600;
        margin-bottom: clamp(0.5rem, 1.2vw, 0.75rem);
        color: var(--text-primary, rgba(55, 65, 81, 0.9));
        line-height: 1.4;
        letter-spacing: -0.01em;
        cursor: pointer;

        .required-indicator {
            color: #ef4444;
            margin-left: 0.125rem;
            font-weight: 700;
        }
    }

    .field-label-input {
        font-size: clamp(0.95rem, 2.2vw, 1.1rem);
        font-weight: 600;
        margin-bottom: clamp(0.5rem, 1.2vw, 0.75rem);
        color: var(--text-primary, rgba(55, 65, 81, 0.9));
        line-height: 1.4;
        letter-spacing: -0.01em;
        border: none;
        background: transparent;
        outline: none;
        border-bottom: 2px solid #f26a52;
        padding: 0 0 2px 0;

        &::placeholder {
            color: rgba(156, 163, 175, 0.7);
        }
    }

    .input-container {
        position: relative;
        min-width: 0;
    }

    .input-wrapper {
        position: relative;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

        input {
            width: 100%;
            padding: clamp(0.6rem, 1.5vw, 0.75rem) clamp(0.6rem, 1.2vw, 0.75rem);
            font-size: clamp(0.875rem, 1.8vw, 0.9rem);
            line-height: 1.4;
            color: var(--text-primary, rgba(55, 65, 81, 0.9));
            background: rgba(255, 255, 255, 0.8);
            border: 1px solid rgba(209, 213, 219, 0.6);
            border-radius: 0.375rem;
            box-sizing: border-box;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            font-family: inherit;
            backdrop-filter: blur(10px);

            &::placeholder {
                color: rgba(107, 114, 128, 0.6);
            }

            &:focus {
                outline: none;
                border-color: #f26a52;
                background: rgba(255, 255, 255, 0.95);
                box-shadow:
                    0 0 0 3px rgba(242, 106, 82, 0.1),
                    0 4px 12px rgba(0, 0, 0, 0.05);
                transform: translateY(-1px);
            }

            &:hover:not(:focus) {
                border-color: rgba(107, 114, 128, 0.4);
                background: rgba(255, 255, 255, 0.85);
            }
        }

        .input-border {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 2px;
            background: linear-gradient(90deg, #f26a52, #e55a42);
            border-radius: 1px;
            transform: scaleX(0);
            transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        &.focused .input-border,
        input:focus ~ .input-border {
            transform: scaleX(1);
        }
    }

    .input-label {
        display: block;
        font-size: clamp(0.75rem, 1.6vw, 0.8rem);
        color: rgba(107, 114, 128, 0.8);
        margin-top: clamp(0.25rem, 0.8vw, 0.375rem);
        font-weight: 500;
        transition: color 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }
}

/* Alignment Classes */
.short-text-align-left {
            display: flex;
    align-items: flex-start;
    gap: clamp(0.75rem, 2vw, 1rem);
    text-align: left;

    .field-label, .field-label-input {
        min-width: clamp(100px, 20vw, 140px);
        flex-shrink: 0;
        margin-bottom: 0;
        padding-top: clamp(0.6rem, 1.5vw, 0.75rem);
        text-align: left;
    }

    .input-container {
        flex: 1;
    }

    @media (max-width: 768px) {
            flex-direction: column;
        gap: 0;

        .field-label, .field-label-input {
            min-width: auto;
            padding-top: 0;
            margin-bottom: clamp(0.5rem, 1.2vw, 0.75rem);
        }

        .input-container {
            width: 100%;
        }
    }
}

.short-text-align-right {
    display: flex;
    align-items: flex-start;
    gap: clamp(0.75rem, 2vw, 1rem);

    .field-label, .field-label-input {
        min-width: clamp(100px, 20vw, 140px);
        flex-shrink: 0;
        margin-bottom: 0;
        padding-top: clamp(0.6rem, 1.5vw, 0.75rem);
        text-align: right;
    }

    .input-container {
        flex: 1;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 0;

        .field-label, .field-label-input {
            min-width: auto;
            padding-top: 0;
            margin-bottom: clamp(0.5rem, 1.2vw, 0.75rem);
            text-align: left;
        }

        .input-container {
                width: 100%;
        }
    }
}

.short-text-align-top {
                text-align: left;
    flex-direction: column;
}

@media (max-width: 768px) {
    .short-text {
        margin: clamp(0.25rem, 1vw, 0.5rem) auto;
        padding: clamp(0.5rem, 1.2vw, 0.75rem);

        .field-label {
            font-size: clamp(0.9rem, 2vw, 1rem);
            margin-bottom: clamp(0.375rem, 1vw, 0.5rem);
        }

        .input-wrapper {
            input {
                padding: clamp(0.75rem, 2vw, 0.875rem);
                font-size: clamp(0.875rem, 2vw, 0.9rem);
                border-radius: 0.5rem;
            }
        }
    }
}

@media (prefers-reduced-motion: reduce) {
    .short-text, .input-wrapper, .input-wrapper input, .input-border {
        transition: none;
    }

    .input-wrapper input:focus {
        transform: none;
    }
}

.input-wrapper {
    will-change: transform;

    input {
        will-change: transform, box-shadow;
    }

    .input-border {
        will-change: transform;
    }
}
</style>
